module.exports = __webpack_public_path__ + "static/img/list-primary.00a2c6f8.svg";